import './SuggestionGroupLabel.scss';

type Props = Readonly<{
  id?: string;
  text: string;
}>;

export default function SuggestionGroupLabel({ id, text }: Props): JSX.Element {
  return (
    // eslint-disable-next-line jsx-a11y/prefer-tag-over-role -- custom implementation
    <div id={id} role='presentation' className='suggestion-group-label'>
      <strong>{text}</strong>
    </div>
  );
}
